import React, { useRef } from 'react';
import configurationAPI from '../api/configurationHeaders';
import { App, ConfigProvider, Layout } from 'antd';
import { UserManagementTool } from './aamUserManagementTool/UserManagementTool';
import { RootStoreContext } from '../root-store-context';
import RootStore from '../stores/root-store';
import { Content, Footer} from 'antd/es/layout/layout';

const AamUserManagementTool = ({
    link,
    xApiKey,
}: {
    link: string;
    xApiKey: string;
}) => {
    // Configure axios synchronously during render so that the base URL and
    // auth headers are ready before child components mount and fire their
    // initial API calls. Using useEffect would defer this until after the
    // first paint, causing a race condition where the API fires without headers.
    const prevLink = useRef<string | null>(null);
    const prevApiKey = useRef<string | null>(null);

    if (prevLink.current !== link || prevApiKey.current !== xApiKey) {
        configurationAPI.configurationBaseURL(link);
        configurationAPI.configurationHeaders(xApiKey);
        prevLink.current = link;
        prevApiKey.current = xApiKey;
    }

    return (
        <ConfigProvider>
            <div className="App" style={{ width: '100%'}}>
                <RootStoreContext.Provider value={new RootStore()}>
                    <Layout>
                        <Content style={{ paddingInline: 10 }}>
                            <App>
                                <UserManagementTool />
                            </App>
                        </Content>
                        <Footer />
                    </Layout>
                </RootStoreContext.Provider>
            </div>
        </ConfigProvider>
    );
};

export default AamUserManagementTool;
